import { panic } from '@pkgs/api/utils/panic';
import { CustomFetchClient } from '@pkgs/api/utils/customFetchClient';
import { type HttpRequestConfig } from '@pkgs/api/types/http';
import { type ApiConfig } from '@pkgs/api/types/api';
import { AI_CHAT_BOT_ENV_URL_MAP } from '@pkgs/api/constants';

export const customInstance = async <T>(config: HttpRequestConfig, apiConfig?: ApiConfig): Promise<T> => {
  if (!apiConfig?.applicationKey) {
    panic('x-application-key is required');
  }

  const client = new CustomFetchClient({
    defaultBaseURL: AI_CHAT_BOT_ENV_URL_MAP[apiConfig?.environment ?? 'prod'],
    defaultMaxRetryCount: 3,
    defaultRetryDelayMs: 250,
    defaultRetryStatusCodes: [429],
  });

  return client.request<T>(config, apiConfig);
};
